/* eslint-disable */
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import asyncComponent from './utils/asyncComponent';
/* eslint-disabled */

const home = asyncComponent(() => import('./pages/home'));
const defaultPage = asyncComponent(() => import('./pages/default'));
const applePage = asyncComponent(() => import('./pages/apple'));

class App extends Component {
  render() {
    return (
      <div className="page">
        <Switch>
          <Route path='/apple-app-site-association' component={applePage}/>
          <Route path='/home' component={home}/>
          <Route path='/defaultPage' component={defaultPage}/>
          <Route path='/' component={home}/>
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js